import { render, staticRenderFns } from "./PickupLocations.vue?vue&type=template&id=144c30a2&"
import script from "./PickupLocations.vue?vue&type=script&lang=ts&"
export * from "./PickupLocations.vue?vue&type=script&lang=ts&"
import style0 from "./PickupLocations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144c30a2')) {
      api.createRecord('144c30a2', component.options)
    } else {
      api.reload('144c30a2', component.options)
    }
    module.hot.accept("./PickupLocations.vue?vue&type=template&id=144c30a2&", function () {
      api.rerender('144c30a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/checkout/shipping/PickupLocations.vue"
export default component.exports